import React, { Component } from 'react';
import Slider from 'material-ui/Slider';
import Paper from 'material-ui/Paper';
import './Question.css';

class Question extends Component {
  render() {
    return (
      <Paper zDepth={1} className="question">
        <p>{this.props.text}</p>
        <div className="input">
          <div className="less">Less</div>
          <Slider
            className={`slider value-${this.props.value}`}
            min={1}
            max={5}
            step={1}
            value={this.props.value}
            onChange={this.props.onChange}
          />
          <div className="more">More</div>
        </div>
      </Paper>
    );
  }
}

Question.propTypes = {
  text: React.PropTypes.string,
  value: React.PropTypes.number,
  onChange: React.PropTypes.func,
};

export default Question;



// WEBPACK FOOTER //
// ./src/Question.js